import { localize } from "client_legacy/ndaw/culture";

class ConversionError<TInputValue = unknown> {
	public readonly inputValue: TInputValue;
	public readonly message: string;

	constructor (inputValue: TInputValue, message: string) {
		this.inputValue = inputValue;
		this.message = message;
	}
}

interface IInputValueConverter<TValue, TInputValue> {
	formatValue(value: TValue): TInputValue;
	parseValue(inputValue: TInputValue): TValue | ConversionError<TInputValue>;
}

const numberConverter: IInputValueConverter<number | null, string> = {
	formatValue(value: number | null): string {
		if (value === null) {
			return "";
		}

		return value.toString();
	},
	parseValue(inputValue: string): number | null | ConversionError<string> {
		if (inputValue === "") {
			return null;
		}

		const parsedValue: number = parseFloat(inputValue);

		if (isNaN(parsedValue) || parsedValue.toString() !== inputValue) {
			return new ConversionError(inputValue, localize("_MustBeNumber"));
		}

		return parsedValue;
	}
};

const integerConverter: IInputValueConverter<number | null, string> = {
	formatValue(value: number | null): string {
		if (value === null) {
			return "";
		}

		return value.toString(10);
	},
	parseValue(inputValue: string): number | null | ConversionError<string> {
		if (inputValue === "") {
			return null;
		}

		const parsedValue: number = parseInt(inputValue, 10);

		if (isNaN(parsedValue)
			|| parsedValue > Number.MAX_SAFE_INTEGER
			|| parsedValue < Number.MIN_SAFE_INTEGER
			|| parsedValue.toString(10) !== inputValue
		) {
			return new ConversionError(inputValue, localize("_MustBeNumber"));
		}

		return parsedValue;
	}
};

export {
	type IInputValueConverter,
	numberConverter,
	integerConverter,
	ConversionError
};